import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import trTRTranslations from './tr-tr'

export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations,
  'tr-TR': trTRTranslations,
}